export default {
  MN: '1px',
  TN: '2px',
  XXS: '3px',
  XS: '4px',
  SM: '5px',
}
